import React, { useState, useContext } from "react";
import { AuthContext } from "../store/AuthContext";

import StepOneTC from "../components/forms/StepOneTC";
import StepTwoTC from "../components/forms/StepTwoTC";
import StepThreeTC from "../components/forms/StepThreeTC";
import StepFourTC from "../components/forms/StepFourTC";

function FormTC() {

  const { handleLogout, timer } = useContext(AuthContext); 


  const userInfo = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  const [step, setstep] = useState(1);
  const [formData, setFormData] = useState({
    nome: userInfo.nome,
    cpf: userInfo.cpf,
    email: userInfo.email,
    nomeSocial: "",
    dtNascimento: "",
    sexo: "",
    estadoCivil: "",
    dependente: "",
    tipoDoc: "",
    docIdentificacao: "",
    orgEmissor: "",
    dtEmissao: "",
    escolaridade: "",
    ultimaSerie: "",
    estudante: "",
    deficiente: "",
    nomePai: "",
    nomeMae: "",
    naturalidade: "",
    nacionalidade: "",
    fone1: "",
    fone2: "",
    renda: "",
    rendaFamiliar: "",
    estado: "",
    cidade: "",
    bairro: "",
    logradouro: "",
    cep: "",
    numero: "",
    cnpj: "",
    razaoSocial: "",
    contato: "",
    ctps: "",
    serie: "",
    situacao: "",
    pis_pasep: "",
    cargo: "",
    dtAdmissao: "",
    dtDemissao: "",
    docPerfil: "",
    docComprovante: "",
    docFrente: "",
    docVerso: "",
    docCpf: "",
    docContrato: "",
    docCTPS: "",
    docHolerite: "",
  });

  const nextStep = () => {
    setstep(step + 1);
  };

  const prevStep = () => {
    setstep(step - 1);
  };

  const handleInputData = (input) => (e) => {
    // input value from the form
    const { value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [input]: value,
    }));
  };
   
  

  if (timer === 0) {
    handleLogout();
  }
  if (timer < 3) {
    return (
      <>
        <p className="text-white">
          Em {timer} segundos, você será desconectado automaticamente...
        </p>
      </>
    );
  }



  // javascript switch case to show different form in each step
  switch (step) {
    // case 1 to show stepOne form and passing nextStep, prevStep, and handleInputData as handleFormData method as prop and also formData as value to the fprm
    case 1:
      return (
        <div className="container">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <StepOneTC
                nextStep={nextStep}
                prevStep={prevStep}
                handleFormData={handleInputData}
                values={formData}
              />
            </div>
          </div>
        </div>
      );

    // case 2 to show stepTwo form passing nextStep, prevStep, and handleInputData as handleFormData method as prop and also formData as value to the fprm
    case 2:
      return (
        <div className="container">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <StepTwoTC
                nextStep={nextStep}
                prevStep={prevStep}
                handleFormData={handleInputData}
                values={formData}
              />
            </div>
          </div>
        </div>
      );

    // case 2 to show stepTwo form passing nextStep, prevStep, and handleInputData as handleFormData method as prop and also formData as value to the fprm
    case 3:
      return (
        <div className="container">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <StepThreeTC
                nextStep={nextStep}
                prevStep={prevStep}
                handleFormData={handleInputData}
                values={formData}
              />
            </div>
          </div>
        </div>
      );

    case 4:
      return (
        <div className="container">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <StepFourTC
                nextStep={nextStep}
                prevStep={prevStep}
                handleFormData={handleInputData}
                values={formData}
              />
            </div>
          </div>
        </div>
      );

    // default case to show nothing
    default:
      return <div className="App"></div>;
  }
}

export default FormTC;
